import { Box, Grid, Container } from '@mui/material';
import { VerifiedUser } from '@mui/icons-material';

// Components
import SiteBranding from '../../base/branding/sitebranding';
import Footer from '../../base/layout/Footer';

export default function AppUserPasswordResetAnonymousSent() {
  return (
    <>
      <div className='app'>
        <main className='content'>
          <div className='content_body'>
            <Container maxWidth={'md'}>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <SiteBranding className='logo' />
              </Box>
              <Grid xs={12} minHeight={250}>
                <Grid item={true} xs={12}>
                  <Box display='flex' justifyContent='center' paddingTop={5} minHeight={10}>
                    <VerifiedUser color='success' fontSize='large' />
                  </Box>
                </Grid>
                <Grid item={true} xs={12}>
                  <Box display='flex' justifyContent='center' paddingTop={5} minHeight={30}>
                    <h1>Check your inbox!</h1>
                  </Box>
                </Grid>
                <Grid item={true} xs={12}>
                  <p>If we found you in the system we have sent you an email with a link that you may use to set a new password for yourself.</p>
                  <p>
                    <em>The link is valid for 30 minutes</em>.
                  </p>
                </Grid>
              </Grid>
              <Footer />
            </Container>
          </div>
        </main>
      </div>
    </>
  );
}
